/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import ReactHighlightWords from "react-highlight-words"

interface HighlighterProps {
  searchWords: string[]
  textToHighlight: string
}

export const Highlighter: React.FC<HighlighterProps> = ({
  searchWords,
  textToHighlight,
}) => {
  return (
    <ReactHighlightWords
      sx={{
        "& mark": {
          bg: "highlight",
          fontWeight: "medium",
        },
      }}
      searchWords={searchWords}
      autoEscape={true}
      textToHighlight={textToHighlight}
    />
  )
}
